"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Do not edit directly
 */

const spacing = {
  inset: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem'
  },
  insetSquished: {
    xs: {
      x: '0.5rem',
      y: '0.25rem'
    },
    sm: {
      x: '0.75rem',
      y: '0.5rem'
    },
    md: {
      x: '0.75rem',
      y: '1rem'
    },
    lg: {
      x: '1rem',
      y: '1.25rem'
    },
    xl: {
      x: '1.5rem',
      y: '1.75rem'
    }
  },
  insetStretched: {
    xs: {
      x: '0.25rem',
      y: '0.5rem'
    },
    sm: {
      x: '0.5rem',
      y: '0.75rem'
    },
    md: {
      x: '1rem',
      y: '0.75rem'
    },
    lg: {
      x: '1.25rem',
      y: '1rem'
    },
    xl: {
      x: '1.75rem',
      y: '1.5rem'
    }
  },
  stack: {
    xxs: '0.125rem',
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '3rem',
    xxl: '4rem',
    xxxl: '5rem'
  },
  base: 8,
  scale: {
    '100': '0.5rem',
    '150': '0.75rem',
    '200': '1rem',
    '250': '1.25rem',
    '300': '1.5rem',
    '350': '1.75rem',
    '400': '2rem',
    '500': '2.5rem',
    '600': '3rem',
    '700': '3.5rem',
    '800': '4rem',
    '900': '4.5rem',
    '1000': '5rem',
    '025': '0.125rem',
    '050': '0.25rem',
    '075': '0.375rem'
  },
  component: {
    button: {
      sizeXs: {
        inset: {
          default: {
            x: '0.5rem',
            y: '0.25rem'
          },
          iconLeft: {
            left: '0.375rem',
            right: '0.5rem',
            y: '0.25rem'
          },
          iconRight: {
            left: '0.5rem',
            right: '0.375rem',
            y: '0.25rem'
          }
        }
      },
      sizeSm: {
        inset: {
          default: {
            x: '0.75rem',
            y: '0.5rem'
          },
          iconLeft: {
            left: '0.5rem',
            right: '0.75rem',
            y: '0.5rem'
          },
          iconRight: {
            left: '0.75rem',
            right: '0.5rem',
            y: '0.5rem'
          }
        }
      },
      sizeMd: {
        inset: {
          default: {
            x: '1rem',
            y: '0.625rem'
          },
          iconLeft: {
            left: '0.75rem',
            right: '1rem',
            y: '0.5rem'
          },
          iconRight: {
            left: '1rem',
            right: '0.75rem',
            y: '0.5rem'
          }
        }
      },
      sizeLg: {
        inset: {
          default: {
            x: '1.25rem',
            y: '0.875rem'
          },
          iconLeft: {
            left: '0.75rem',
            right: '1.25rem',
            y: '0.75rem'
          },
          iconRight: {
            left: '1.25rem',
            right: '0.75rem',
            y: '0.75rem'
          }
        }
      },
      sizeXl: {
        inset: {
          default: {
            x: '1.75rem',
            y: '1.375rem'
          },
          iconLeft: {
            left: '1.25rem',
            right: '1.75rem',
            y: '1rem'
          },
          iconRight: {
            left: '1.75rem',
            right: '1.25rem',
            y: '1rem'
          }
        }
      }
    },
    card: {
      sizeSm: {
        header: {
          padding: '0.5rem',
          content: {
            padding: '0.5rem'
          }
        },
        body: {
          paddingBlock: {
            start: '1rem',
            end: '1.25rem'
          },
          paddingInline: '1rem'
        },
        footer: {
          paddingBlock: {
            start: '1rem',
            end: '1.25rem'
          },
          paddingInline: '1rem'
        }
      },
      sizeMd: {
        header: {
          padding: '1rem',
          content: {
            padding: '0.5rem'
          }
        },
        body: {
          paddingBlock: {
            start: '1.5rem',
            end: '1.75rem'
          },
          paddingInline: '1.5rem'
        },
        footer: {
          paddingBlock: {
            start: '1.5rem',
            end: '1.75rem'
          },
          paddingInline: '1.5rem'
        }
      }
    },
    focusRing: '0.4375rem'
  }
};
var _default = exports.default = spacing;